var __rspack_ns_object = JSON.parse('{"UU":"@atlassian/browser-storage-controls","rE":"10.37.3"}')